// Breadcrumb bar at the top of a page (moved from the webapp SecondaryBar, without the store and the router).
// No style import: the app loads "@wine2trace/ui/SecondaryBar/styles/bar" (the webapp at the original position).
//   baseLabel    first item (the winery), already translated; none = not shown
//   breadCrumb   the pages after it: a text, or { label, link } (clickable)
//   onNavigate   called with the link of a clickable page
const SecondaryBar = ({ baseLabel = null, breadCrumb, onNavigate = () => {} }) => (
  <div className="secondary_bar_container">
    <div className="secondary_bar_title">
      {baseLabel && <span>{baseLabel}</span>}
      {breadCrumb?.map((page, index) => {
        if (typeof page === "object" && page.link) {
          return (
            <span key={index} onClick={() => onNavigate(page.link)} className="secondary_bar_link">
              {page.label}
            </span>
          );
        }
        return <span key={index}>{page}</span>;
      })}
    </div>
  </div>
);

export default SecondaryBar;
